<template>
  <span>
    <div>
      <h5>new post</h5>
      title <input type='text' v-model='newTitle' /> <br>
      post <textarea type='text' v-model='newPost' ></textarea> <br>
      <button @click='createPost'>send post</button>
      <br>
      <table >
        <tr>
          <th>title</th>
          <th>post</th>
          <th>date</th>
          <th></th>
        </tr>
        <tr v-for='post in posts' :key='post.dateAdded' >
          <td><input v-model='post.title' /></td>
          <td><textarea v-model='post.post' ></textarea></td>
          <td><input v-model='post.dateAdded' /></td>
          <td><button @click='updatePost(post)'>edit</button></td>
          <td><button @click='deletePost(post)'>delete</button></td>
        </tr>
      </table >
      </div>
  </span>
</template>

<script>
export default {
  name: 'admin-post',
  data () {
    return {
      newTitle: '',
      newPost: '',
      posts: [],
      update: {}
    }
  },
  mounted () {
    this.loadPost()
  },
  methods: {
    loadPost () {
      this.$http.get('/posts').then(response => {
        this.posts = response.data
      })
    },
    createPost () {
      this.$http.post(
        '/posts' + '?key=' + this.$parent.key + '&title=' + this.newTitle + '&post=' + this.newPost
      ).then(this.loadPost())
    },
    updatePost (post) {
      const id = post._id
      delete post._id
      this.$http.put(
        '/posts/' + id + '?update=' + JSON.stringify(post) + '&key=' + this.$parent.key
      ).then(this.loadPost())
    },
    deletePost (post) {
      this.$http.delete(
        '/posts/' + post._id + '?key=' + this.$parent.key
      ).then(() => {
        this.loadPost()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdminPosts.vue